import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { useContext } from "react";
import { ThemeContext } from "../components/ThemeContext";
import logo from "../assets/images/logo.png";
import "./ResetPassword.css";

const ResetPassword = () => {
  const { theme } = useContext(ThemeContext);
  const [identifier, setIdentifier] = useState("");
  const [countryCode, setCountryCode] = useState("+91");
  const [error, setError] = useState("");
  const [notice, setNotice] = useState("");
  const isPhone = /^[+\d][\d\s().-]*$/.test(identifier.trim()) && /\d/.test(identifier);

  useEffect(() => {
    document.title = "Reset password | TillionX";
  }, []);

  const submitRecovery = (event) => {
    event.preventDefault();
    setError("");
    setNotice("");
    if (!identifier.trim()) {
      setError("Enter the email address or phone number linked to your account.");
      return;
    }
    setNotice("Password recovery is not available yet. Contact Support for help with your account.");
  };

  return (
    <main className={`reset-page ${theme === "light" ? "reset-light" : ""}`}>
      <section className="reset-card" aria-label="Reset your password">
        <Link className="reset-brand" to="/" aria-label="TillionX home"><img src={logo} alt="TillionX" /></Link>
        <h1>Reset password</h1>
        <p className="reset-intro">Enter the email or phone number associated with your account.</p>
        <form onSubmit={submitRecovery}>
          <label htmlFor="recovery-identifier">Email/Phone number</label>
          <div className={`reset-input-row ${isPhone ? "is-phone" : ""}`}>
            {isPhone && <select aria-label="Country calling code" value={countryCode} onChange={(event) => setCountryCode(event.target.value)}>
              <option value="+91">🇮🇳 +91</option>
              <option value="+1">🇺🇸 +1</option>
              <option value="+44">🇬🇧 +44</option>
              <option value="+61">🇦🇺 +61</option>
              <option value="+86">🇨🇳 +86</option>
              <option value="+81">🇯🇵 +81</option>
              <option value="+971">🇦🇪 +971</option>
            </select>}
            <div className="reset-input-wrap">
              <input id="recovery-identifier" type="text" autoComplete="username" placeholder="Email or phone number" value={identifier} onChange={(event) => { setIdentifier(event.target.value); setNotice(""); }} />
              {identifier && <button type="button" aria-label="Clear email or phone number" onClick={() => { setIdentifier(""); setNotice(""); }}><XMarkIcon /></button>}
            </div>
          </div>
          {error && <p role="alert" className="reset-error">{error}</p>}
          {notice && <p role="status" className="reset-notice">{notice}</p>}
          <button className="reset-submit" type="submit">Continue</button>
        </form>
        <div className="reset-footer"><Link to="/login">Back to log in</Link><Link to="/support-center">Contact Support</Link></div>
      </section>
    </main>
  );
};

export default ResetPassword;
